export default "__VITE_ASSET__X03KYWGi__"